import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {SERVER_API_URL} from 'src/app/app.constants';
import {IInsuranceCompanyMySuffix} from 'src/app/shared/model/insurance-company-my-suffix.model';
import {createRequestOption} from 'src/app/shared/util/request-util';

type EntityResponseType = HttpResponse<IInsuranceCompanyMySuffix>;
type EntityArrayResponseType = HttpResponse<IInsuranceCompanyMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class InsuranceCompanyMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/insurance-companies';
    private rUrl = SERVER_API_URL + 'api/insurance-companies-list';
    private surveyAssociationUrl = SERVER_API_URL + 'api/survey-associations-active';

    constructor(private http: HttpClient) {}

    create(insuranceCompany: IInsuranceCompanyMySuffix): Observable<EntityResponseType> {
        return this.http.post<IInsuranceCompanyMySuffix>(this.resourceUrl, insuranceCompany, { observe: 'response' });
    }

    update(insuranceCompany: IInsuranceCompanyMySuffix): Observable<EntityResponseType> {
        return this.http.put<IInsuranceCompanyMySuffix>(this.resourceUrl, insuranceCompany, { observe: 'response' });
    }
    
    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IInsuranceCompanyMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    
    view(id: number): Observable<EntityResponseType> {
        return this.http.get<IInsuranceCompanyMySuffix>(`${this.resourceUrl}/view/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IInsuranceCompanyMySuffix[]>(this.resourceUrl+'/info', { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    accessPlatform(id: number): Observable<HttpResponse<any>> {
        return this.http.get<any>(`${this.resourceUrl}/access-platform/${id}`, { observe: 'response' });
    }

    queryAll(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IInsuranceCompanyMySuffix[]>(this.resourceUrl + '/all', { params: options, observe: 'response' });
    }
    getAllActiveInsuranceCompanies(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IInsuranceCompanyMySuffix[]>(this.resourceUrl + '/active', { params: options, observe: 'response' });
    }

    getAllInsuranceCompaniesWithUId(id: number, req?: any): Observable<EntityArrayResponseType> {
        return this.http.get<IInsuranceCompanyMySuffix[]>(`${this.rUrl}/${id}`, { observe: 'response' });
    }

    getSurveyAssociations(): Observable<EntityArrayResponseType> {
        return this.http.get<IInsuranceCompanyMySuffix[]>(this.surveyAssociationUrl, { observe: 'response' } );
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IInsuranceCompanyMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }
    
    
    checkForInsurerInPolicy(id: any) {
       return this.http.get<any>(SERVER_API_URL+`api/check-for-insurers-in-policies/${id}`, { observe: 'response' });
    }


    checkStandardSurveyEnabled(): Observable<HttpResponse<any>> {
        return this.http.get<any>(`${SERVER_API_URL}api/users/insurance-companies-underwriters/standard-survey`, { observe: 'response' });
    }
}
